const autoSwitchCarousel = [
    {
        selector: '[data-react="autoSwitchCarousel"]',
        path: { filename: 'App' },
    },
];

export { autoSwitchCarousel };
